import { Injectable } from '@angular/core';
import { ColumnRepository, DataRepository, RecordTypeEnum } from '@database/workspace';
import { DataModel, PrimaryKeyValueModel } from '@shared';
import { combineLatest, iif, map, Observable, of, switchMap } from 'rxjs';

@Injectable()
export class PreviousRecordService {
	public constructor(
		private columnRepository: ColumnRepository,
		private dataRepository: DataRepository
	) {}

	public getPreviousRecord$(
		tableName: string,
		projectNumber: string,
		primaryKeyValue: PrimaryKeyValueModel[]
	): Observable<DataModel | null> {
		return combineLatest([
			this.columnRepository.hasDepthsColumns$(tableName),
			this.columnRepository.hasInheritedColumns$(tableName)
		]).pipe(
			switchMap(([hasDepthsColumns, hasInheritedColumns]) => {
				const recordType = hasDepthsColumns ? RecordTypeEnum.depthFromToRecordType : RecordTypeEnum.normal;

				return iif(
					() => hasDepthsColumns || hasInheritedColumns,
					this.dataRepository.getLastRecord$(tableName, projectNumber, primaryKeyValue, recordType).pipe(
						map((tableData: DataModel | null) => {
							if (!tableData) {
								return null;
							}

							return tableData;
						})
					),
					of(null)
				);
			})
		);
	}
}
